<template>
  <span @click="copyToClipboard(text)" class="copy-to-clipboard">
    <fa-icon :icon="['fal', 'copy']" />
  </span>
</template>
<script>
import { copyToClipboard } from '@/common/utils'

export default {
  props: {
    text: {type: String, required: true}
  },
  methods: {
    copyToClipboard
  }
}
</script>



// WEBPACK FOOTER //
// src/components/utils/CopyToClipboard.vue